<template>
  <div class="course-assigner">
    <volunteers-selector @onSubmit="onPublishCourse" btn-label="حفظ التغيرات" />
  </div>
</template>

<script>
import { RepositoryFactory } from "../../volunteer-repositories/volunteerRepositoryFactory";
import VolunteersSelector from "@/app/volunteer/components/VolunteersSelector.vue";

const coursesRepo = RepositoryFactory.get("coursesRepository");

export default {
  name: "CourseAssigner",
  components: {
    VolunteersSelector,
  },
  data() {
    return {
      permissions: {
        // add: 'courses_management',
        // edit: 'courses_management',
        // delete: 'courses_management',
      }
    };
  },
  methods: {
    async onPublishCourse(payload) {
      const courseId = this.$route.params.id;
      const _payload = {
        excludedVolunteerIds: payload.excludedVolunteer
      };
      return await coursesRepo.publishCourse(
        {
          courseId,
          payload: _payload,
          query: payload.query
        }
      );
    },
  },
};
</script>
